export enum Constants {
  SET_CONTEST = '@postContest/set_contest',
  SET_ENABLED_CONTEST = '@postContest/set__enabled_contest',
  SET_USER = '@postContest/set_user',
  SET_OPPONENT = '@postContest/set_opponent',
  SET_USER_SORT = '@postContest/set_user_sort',
  SET_PLAYER_SORT = '@postContest/set_player_sort',
  SET_LINEUP_SORT = '@postContest/set_lineup_sort',
  SET_STACK_SORT = '@postContest/set_stack_sort',
  SET_PAGE = '@postContest/set_page',
  SET_USER_ROI = '@postContest/set_user_roi',
  SET_USER_NAME_ROI = '@postContest/set_user_name_roi',
  SET_PLAYER_ALL_ROI = '@postContest/set_player_all_roi',
  SET_PLAYER_USER_ROI = '@postContest/set_player_user_roi',
  SET_PLAYER_OPPONENT_ROI = '@postContest/set_player_opponent_roi',
  SET_LINEUP_ALL_ROI = '@postContest/set_lineup_all_roi',
  SET_LINEUP_USER_ROI = '@postContest/set_lineup_user_roi',
  SET_LINEUP_OPPONENT_ROI = '@postContest/set_lineup_opponent_roi',
  SET_USER_ROI_PAGINATION = '@postContest/set_user_roi_pagination',
  SET_USER_NAME_ROI_PAGINATION = '@postContest/set_user_name_roi_pagination',
  SET_PLAYER_ALL_ROI_PAGINATION = '@postContest/set_player_all_roi_pagination',
  SET_PLAYER_USER_ROI_PAGINATION = '@postContest/set_player_user_roi_pagination',
  SET_PLAYER_OPPONENT_ROI_PAGINATION = '@postContest/set_player_opponent_roi_pagination',
  SET_LINEUP_ALL_ROI_PAGINATION = '@postContest/set_lineup_all_roi_pagination',
  SET_LINEUP_USER_ROI_PAGINATION = '@postContest/set_lineup_user_roi_pagination',
  SET_LINEUP_OPPONENT_ROI_PAGINATION = '@postContest/set_lineup_opponent_roi_pagination',
  SET_STACK_ALL_ROI_PAGINATION = '@postContest/set_stack_all_roi_pagination',
  SET_STACK_USER_ROI_PAGINATION = '@postContest/set_stack_all_roi_pagination',
  SET_STACK_OPP_ROI_PAGINATION = '@postContest/set_stack_all_roi_pagination',
  SET_STACK_ALL_ROI = '@postContest/set_stack_all_roi',
  SET_STACK_USER_ROI = '@postContest/set_stack_user_roi',
  SET_STACK_OPP_ROI = '@postContest/set_stack_opp_roi',
  SET_DATE = '@postContest/set_date',
  SET_SLATES = '@postContest/set_slates',
}